@if (messageService.message(); as message) {
  <div [class]="'flash-message flash-message--' + message.type" role="alert">
    <span>{{ message.text }}</span>
    <button type="button" aria-label="Dismiss message" (click)="messageService.dismiss()">×</button>
  </div>
}
